import { render, staticRenderFns } from "./veStuHygieneNorm.vue?vue&type=template&id=01da5063&scoped=true"
import script from "./veStuHygieneNorm.vue?vue&type=script&lang=js"
export * from "./veStuHygieneNorm.vue?vue&type=script&lang=js"
import style0 from "./veStuHygieneNorm.vue?vue&type=style&index=0&id=01da5063&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da5063",
  null
  
)

export default component.exports